import { MatchesListBase } from '~/web-frontend-core/store/line/matchesList/Base';
export { MatchesListBase as MatchesList };
let instance;
let lastConfg = '';
export const getInstance = (cfg) => {
    if (instance) {
        if (JSON.stringify(cfg) === lastConfg) {
            return instance;
        }
        lastConfg = JSON.stringify(cfg);
        instance.reinit(cfg);
        return instance;
    }
    if (cfg.isMobile) {
        instance = new MatchesListBase(cfg);
        return instance;
    }
    instance = new MatchesListBase(cfg);
    return instance;
};



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/MatchesList.js